// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1b859af6","551":"738de1bf","851":"aec20ba3"}[chunkId] + ".chunk.js";
};